import { NotificationEventName as EventName } from '@models/notifications/notificationEventTypeNames.enum';
import { StorageService } from './storage.service';
import { Injectable } from '@angular/core';

@Injectable()
export class BrowserPushNotificationService {
  // Allow specific notification event types to be listened on with Browser Push Notifications
  newTaskBrowserPush_EVENT_NAMES = [EventName.NEW_TASK];
  ownOfferBrowserPush_EVENT_NAMES = [
    EventName.NEW_COMMENT_ON_FOLLOWED_TASK,
    EventName.OFFER_ACCEPTED,
    EventName.OFFER_INCREASE_ACCEPTED,
    EventName.OFFER_INCREASE_BY_TO,
    EventName.OFFER_REJECTED,
    EventName.OFFER_INCREASE_CANCELED,
    EventName.OFFER_EDIT,
    EventName.OFFER_CANCELED,
    EventName.OFFER_REQUEST_ACCEPTED,
    EventName.OFFER_INCREASE_BY_PP,
    EventName.TASK_CANCELLATION_REQUESTED,
    EventName.TASK_CANCELLATION_ACCEPTED,
    EventName.TASK_CANCELLATION_DENIED,
    EventName.TASK_CANCELLATION_UNDO,
    EventName.TASK_CANCELED,
    EventName.TASK_COMPLETED,
    EventName.CREATE_CONFLICT_CASE,
    EventName.PENDING_CONFLICT_CASE,
    EventName.CLOSE_CONFLICT_CASE,
  ];
  ownTaskBrowserPush_EVENT_NAMES = [
    EventName.NEW_OFFER_RECEIVED,
    EventName.NEW_COMMENT_RECEIVED,
    EventName.NEW_OFFER_COMMENT_RECEIVED,
    EventName.TASK_EXPIRE_SOON,
    EventName.CONFLICT_CASE_RESOLVED,
    EventName.TASK_EXPIRED,
    EventName.TASK_ACCEPTED_EXPIRED,
    EventName.REQUEST_COMPLETION,
  ];
  reviewBrowserPush_EVENT_NAMES = [EventName.REVIEW_RECEIVED];
  allCriticalNotificationsBrowserPush_EVENT_NAMES = [
    EventName.PAYOUT_SUCCESS,
    EventName.PAYOUT_FAILURE,
    EventName.VERIFICATION_NEED,
    EventName.REQUEST_OFFER,
    EventName.HH_LIMITATIONS_CHANGED,
    EventName.NEAR_EXPIRED_CONFLICT_CASE,
    EventName.BAN_VIOLATING_COMPLETION_RATE,
    EventName.BAN_FIRST_CANCEL_TASK,
    EventName.BAN_SECOND_CANCEL_TASK,
    EventName.BAN_THIRD_CANCEL_TASK,
    EventName.NEW_MESSAGE,
    EventName.REPORTED_USER,
    EventName.UNREAD_MESSAGES,
  ];

  constructor(private storage: StorageService) {}

  async askPermission() {
    await Notification.requestPermission((result) => {
      console.log('Browser Push Notification Permission: ', result);
      return result;
    });
  }

  checkNotificationSettingsForBrowserPushNotifications(
    notificationEventName: EventName,
  ) {
    try {
      const {
        newTaskBrowserPush,
        ownOfferBrowserPush,
        ownTaskBrowserPush,
        reviewBrowserPush,
      } = this.storage?.notificationSettings;

      if (
        newTaskBrowserPush &&
        this.newTaskBrowserPush_EVENT_NAMES.includes(notificationEventName)
      ) {
        return true;
      }
      if (
        ownOfferBrowserPush &&
        this.ownOfferBrowserPush_EVENT_NAMES.includes(notificationEventName)
      ) {
        return true;
      }
      if (
        ownTaskBrowserPush &&
        this.ownTaskBrowserPush_EVENT_NAMES.includes(notificationEventName)
      ) {
        return true;
      }
      if (
        reviewBrowserPush &&
        this.reviewBrowserPush_EVENT_NAMES.includes(notificationEventName)
      ) {
        return true;
      }
      return this.allCriticalNotificationsBrowserPush_EVENT_NAMES.includes(
        notificationEventName,
      );
    } catch (err) {}
  }

  createNotification(
    title: string,
    message: string,
    type: EventName,
    action: () => void,
  ) {
    if (
      Notification.permission === 'granted' &&
      this.checkNotificationSettingsForBrowserPushNotifications(type)
    ) {
      const notification = new Notification(title, {
        body: message,
        icon: 'https://pinploy-prod.s3.eu-central-1.amazonaws.com/private/lp/hnaydhnadloglo512x.png',
        vibrate: [200, 100, 200],
      });
      notification.onclick = action;
    } else if (
      this.checkNotificationSettingsForBrowserPushNotifications(type)
    ) {
      this.askPermission();
    }
  }
}
